@if (disabled) {
  <button data-ripple-light="true" [class]="disabledClass" disabled>
    <div class="flex items-center">
      @if (faIcon != null) {
        <fa-icon class="mr-1" [icon]="faIcon" />
      }
      {{text}}
    </div>
  </button>
}
@if (!disabled) {
  <button data-ripple-light="true" [style]="class">
    <div class="flex items-center gap-1">
      @if (faIcon != null && !isLoading) {
        <div class="flex justify-center items-center transition duration-200">
          <fa-icon [icon]="faIcon" />
        </div>
      }
      @if (isLoading) {
        <div class="flex justify-center items-center transition duration-200">
          <dot-spinner />
        </div>
      }
      {{text}}
    </div>
  </button>
}
